import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const LeftAlignCheckV2 = ({
  icon,
  name,
  selected,
  onClick,
  value,
  className,
  disabled,
  ...props
}) => (
  <WrapperBg
    bgColor={backgroundColors.normalLeft}
    className={`${className} ${selected && 'selected'}`}
    disabled={disabled}
    {...props}>
    <Wrapper onClick={onClick} className={selected && 'selected'}>
      <TopBox>
        {icon}
        <Input
          type='checkbox'
          bgColor={backgroundColors.normalLeft}
          id={`opt-${value}-${name}`}
          name={name}
          checked={selected}
          onChange={onClick}
        />
      </TopBox>
      <Title>{name}</Title>
    </Wrapper>
  </WrapperBg>
)

export default LeftAlignCheckV2

const WrapperBg = styled.div`
  height: 130px;
  width: 110px;
  border: 1px solid #ececec;
  flex-grow: 1;
  cursor: pointer;

  &:hover,
  &.selected {
    border: none;
    background: ${({ bgColor }) => bgColor};
    padding: 1px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.7;
  `}
`

const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  background: #fff;

  &.selected {
    background: linear-gradient(
        0deg,
        rgba(147, 193, 62, 0.1) 0%,
        rgba(147, 193, 62, 0.1) 100%
      ),
      #fff;
  }
`

const TopBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`

const Title = styled.span`
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    display: none;
    top: 2px;
    left: 7px;
    z-index: 3;
    transform: rotate(45deg);
    height: 10px;
    width: 5px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    box-sizing: content-box !important;
  }

  &:checked {
    &::before {
      content: '';
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: inline-block;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/LeftAlignCheckV2/index.js